<template>
	<el-date-picker :type="type" :value="value" v-on="$listeners" v-bind="computedAttrs" @change="handleChange" />
</template>

<script>
export default {
	name: "CbsDatePicker",
	inheritAttrs: true,
	props: {
		value: {
			required: true
		},
		type: {
			type: String,
			default: "date"
		}
	},
	computed: {
		computedAttrs: function() {
			if (this.$attrs.format) {
				return Object.assign({}, this.$attrs, {
					format: this.$attrs.format
						.split("D")
						.join("d")
						.split("Y")
						.join("y")
				});
			}
			return this.$attrs;
		}
	},
	methods: {
		handleChange(val) {
			this.$emit("change", val);
		}
	}
};
</script>
